import React from 'react'

const AddDaughterIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/add-daughter.svg" : "/assets/icons/add-daughter.svg"}
             alt="add daughter"
             style={props.style}
        />
    )
}

export default AddDaughterIcon